import rootReducer from '@/clients/redux/reducers'
import { ConfigureStoreOptions, configureStore } from '@reduxjs/toolkit'
import logger from 'redux-logger'

type RootState = ReturnType<typeof rootReducer>

// Define the store type
export type AppStore = ReturnType<typeof configureStore<RootState>>
type StoreConfig = Omit<ConfigureStoreOptions<RootState>, 'reducer'>

// Default store configuration
const getDefaultStoreConfig = (): StoreConfig => ({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(logger),
  devTools: true,
})

// Create or return existing store
export const getOrCreateStore = (): AppStore => {
  if (typeof window !== 'undefined') {
    if (window.__REDUX_STORE__) {
      return window.__REDUX_STORE__
    }
  }

  window.__REDUX_STORE__ = configureStore({
    ...getDefaultStoreConfig(),
    reducer: rootReducer,
  })

  return window.__REDUX_STORE__
}

// Export the store
export const store = getOrCreateStore()

// Export types
export type AppState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
